import React, { useState, useEffect } from "react";
import "./PayrollAssociateCreation.scss";
import {
  NewPortaluser,
  PictureNew,
  MerchantPiAdd,
} from "../../util/API/customers";
import CustomForm from "../UI/CustomForm/CustomForm";
import { formatDate } from "../../util/utilfunctions/utilFunctions";
import CustomAlert from "../UI/CustomAlert/CustomAlert";
import { Box, Typography, Chip } from "@mui/material";
import BaseDrawer from "../UI/BaseDrawer/BaseDrawer";
import BusinessIcon from "@mui/icons-material/Business";
import { useSelector, useDispatch } from "react-redux";
import { getSystemStatus } from "../../util/API/admin";
import { decodeHtmlEntities } from "../../util/utilfunctions/utilFunctions";
function PayrollAssociateCreation({
  open,
  handleClose,
  selectedUser, // This is the PARENT Payroll Admin
  updateUser,
  setUpdateUser,
  payrollUsers,
}) {
  // Extract parent admin context from selectedUser
  // The shape from getUserDetails() is selectedUser.User.xxx
  let configVariables = useSelector((state) => state.config.baseConfig);
  const parentAdminId = selectedUser?.User?.id;
  const parentCompanyName = selectedUser?.User?.otherNames || "";
  const requiredConstants = useSelector((state) => state.constants);
  const [phoneError, setPhoneError] = useState("");
  const [zipError, setZipError] = useState("");
  const [roles, setRoles] = useState([]);
  const [alert, setAlert] = useState({
    showAlert: false,
    message: "",
    severity: "",
    header: "",
  });
  const cleanCompanyName = (raw) => {
    if (!raw) return "-";

    let name = String(raw)
      .replace(/&amp;amp;/g, "&")
      .replace(/&amp;#039;/g, "'")
      .replace(/&amp;#39;/g, "'")
      .replace(/&amp;/g, "&")
      .replace(/&#039;/g, "'")
      .replace(/&#39;/g, "'")
      .replace(/&quot;/g, '"')
      .replace(/&#34;/g, '"')
      .replace(/&lt;/g, "<")
      .replace(/&gt;/g, ">")
      .replace(/&nbsp;/g, " ")
      .trim();

    // Optional but highly recommended: extract real company name when it's prefixed like "code:&quot;name&quot;"
    if (name.includes(":")) {
      const parts = name.split(":");
      let extracted = parts[parts.length - 1].trim();
      extracted = extracted.replace(/^["']|["']$/g, ""); // remove wrapping quotes
      if (extracted) name = extracted;
    }

    return name || "-";
  };
  const cleanName = (name) =>
    decodeHtmlEntities(decodeHtmlEntities(name || ""))
      .replace(/[^a-zA-Z0-9\s'&.-]/g, "")
      .replace(/\s+/g, " ")
      .trim();
  const [userBase64, setUserBase64] = useState("");
  const [errors, setError] = useState("");
  const [newUser, setNewUser] = useState("");

  const handleCloseModal = () => {
    handleClose();
    setNewUser("");
    setError("");
    setPhoneError("");
    setZipError("");
  };
  // const systemRoles = async () => {
  //   const allRoles = requiredConstants.systemRoles || [];

  //   const payrollRoleWrapper = allRoles.find(
  //     (roleWrapper) =>
  //       roleWrapper.securityrole.roleid ===
  //       configVariables.associatePayrollAdminId,
  //   );
  //   console.log("payrollRoleWrapper______", payrollRoleWrapper);
  //   let transformedRoles = [];
  //   if (payrollRoleWrapper) {
  //     const role = payrollRoleWrapper.securityrole;
  //     transformedRoles = [
  //       {
  //         key: role.roleid,
  //         value: role.roleid,
  //         label: role.name,
  //       },
  //     ];
  //   } else {
  //     console.warn(
  //       "⚠️ Role ID (Associate Payroll Admin) not found in systemRoles!",
  //     );
  //   }

  //   // setRoles([
  //   //   {
  //   //     key: configVariables.associatePayrollAdminId,
  //   //     value: configVariables.associatePayrollAdminId,
  //   //     label: "Associate Payroll Admin",
  //   //   },
  //   // ]);
  //   setRoles([]);
  // };

  // In systemRoles(), change setRoles([]) back to the actual role:
const systemRoles = async () => {
  const allRoles = requiredConstants.systemRoles || [];
  const payrollRoleWrapper = allRoles.find(
    (roleWrapper) =>
      roleWrapper.securityrole.roleid === configVariables.associatePayrollAdminId,
  );

  if (payrollRoleWrapper) {
    const role = payrollRoleWrapper.securityrole;
    setRoles([
      {
        key: role.roleid,
        value: role.roleid,
        label: role.name,
      },
    ]);
  }
};
  useEffect(() => {
    systemRoles();
  }, [requiredConstants]);
  const validatePhone = (areaCode, phone) => {
    if (!areaCode?.value || !phone?.trim()) return "Phone number is required";
    const fullInput = String(areaCode.value) + String(phone.trim());
    const noSpaces = fullInput.replace(/\s+/g, "");
    if (!/^\+?\d+$/.test(noSpaces))
      return "Phone number must contain only digits";
    const digitsOnly = noSpaces.replace(/\D/g, "");
    if (digitsOnly.length < 7)
      return "Phone number must have at least 7 digits";
    if (digitsOnly.length > 15) return "Phone number cannot exceed 15 digits";
    return "";
  };

  const validateZip = (zip) => {
    if (!zip?.trim()) return "ZIP / Postal Code is required";
    const cleaned = zip.trim();
    if (cleaned.length < 3 || cleaned.length > 10)
      return "ZIP / Postal Code must be 3–10 characters";
    return "";
  };

  const handleSubmit = async (data, formData) => {
    console.log('formData===============', formData)
     const EXCLUDED_FROM_REQUIRED = ["role", "roleid"];
    setNewUser("");
    setError("");
    setPhoneError("");
    setZipError("");
    
    // Guard: make sure we have a parent admin to link to
    if (!parentAdminId) {
      setAlert({
        showAlert: true,
        message:
          "Could not determine the parent Payroll Admin. Please close and try again.",
        severity: "error",
        header: "Missing Context",
      });
      return;
    }

    const phoneErr = validatePhone(data.areaCode, data.phoneno);
    const zipErr = validateZip(data.zip);
    setPhoneError(phoneErr);
    setZipError(zipErr);

    if (phoneErr || zipErr) {
      let errorMsg = "Please fix the following issues:";
      if (phoneErr) errorMsg += `\n- ${phoneErr}`;
      if (zipErr) errorMsg += `\n- ${zipErr}`;
      setAlert({
        showAlert: true,
        message: errorMsg,
        severity: "error",
        header: "Invalid Input",
      });
      return;
    }

    // const requiredFields = formData
    //   .filter((field) => field.validation?.required)
    //   .map((field) => field.name);
    const requiredFields = formData
    .filter(
      (field) =>
        field.validation?.required &&
        !EXCLUDED_FROM_REQUIRED.includes(field.name) // ← skip role fields
    )
    .map((field) => field.name);
    const missingFields = requiredFields.filter(
      (fieldName) =>
        !data[fieldName] || data[fieldName].toString().trim() === "",
    );

    if (missingFields.length > 0) {
      setAlert({
        showAlert: true,
        message: "Please fill all required fields",
        severity: "error",
        header: "Missing Fields",
      });
      return;
    }

    let phoneNo = data.areaCode.value + data.phoneno;
    let requestData = { ...data };

    if (requestData?.dob) requestData.dob = formatDate(requestData.dob);
    if (requestData?.phoneno) requestData.phoneno = phoneNo;

    // Separate core vs extended fields
    let extendedFields = {};
    formData.forEach((item) => {
      if (item.core === 0 && requestData.hasOwnProperty(item.name)) {
        extendedFields[item.name] = requestData[item.name];
        delete requestData[item.name];
      }
    });

    // ── KEY ADDITIONS ──────────────────────────────────────────
    // Link associate to the parent admin's company name
    requestData.otherNames = parentCompanyName;
    // Default role (hidden auto-selection)
    requestData.roleid = configVariables.associatePayrollAdminId;
    // Tell the backend which Payroll Admin owns this associate
    // Adjust the field name to match whatever your backend expects
    requestData.parentUserId = parentAdminId;

    requestData.extendedFields = JSON.stringify(extendedFields);
    // ───────────────────────────────────────────────────────────

    try {
      const response = await NewPortaluser(requestData);
      const callStatus = response.data.Status;

      if (callStatus === "3") {
        const userId = response?.data?.payload?.userid;

        // Same permission grants as Payroll Admin onboarding
        await MerchantPiAdd(userId, 229, 2);
        await MerchantPiAdd(userId, 230, 2);
        await MerchantPiAdd(userId, 313, 42);

        setAlert({
          showAlert: true,
          message:
            "Associate has been created successfully and linked to the company!",
          severity: "success",
          header: "Success",
        });

        if (userBase64) {
          await PictureNew(userId, userBase64);
        }
      } else {
        let backendMsg =
          response?.data?.msg ||
          response?.data?.payload?.msg ||
          response?.data?.payload?.errorMsg ||
          "Failed to create Associate";

        const lowerMsg = backendMsg.toLowerCase();

        if (
          lowerMsg.includes("email") &&
          (lowerMsg.includes("already") ||
            lowerMsg.includes("exists") ||
            lowerMsg.includes("registered") ||
            lowerMsg.includes("duplicate") ||
            lowerMsg.includes("can not be registered"))
        ) {
          backendMsg = "An associate already exists with this email";
        } else if (lowerMsg.includes("invalid email")) {
          backendMsg =
            "Please enter a valid email address (e.g., name@example.com)";
        }

        setError(backendMsg);
        setAlert({
          showAlert: true,
          message: backendMsg,
          severity: "error",
          header: "Creation Failed",
        });
      }
    } catch (error) {
      console.error("Error creating associate:", error);
      setAlert({
        showAlert: true,
        message: "An unexpected error occurred. Please try again.",
        severity: "error",
        header: "Error",
      });
    }
  };

  return (
    <BaseDrawer
      open={open}
      handleClose={handleCloseModal}
      height="90vh"
      title="New Payroll Associate"
    >
      <Box className="portal-creation-container">
        {/* ── Read-only company context banner ── */}
        <Box
          sx={{
            p: 2,
            mb: 3,
            backgroundColor: "#f0fdf4",
            border: "1px solid #bbf7d0",
            borderRadius: "8px",
            display: "flex",
            alignItems: "center",
            gap: 1.5,
          }}
        >
          <BusinessIcon sx={{ color: "#16a34a", fontSize: 20 }} />
          <Box>
            <Typography
              variant="body2"
              sx={{ fontWeight: 600, color: "#15803d" }}
            >
              Creating associate under:
            </Typography>
            <Typography variant="body2" sx={{ color: "#166534" }}>
              {cleanName(parentCompanyName) || "Unknown Company"}
            </Typography>
          </Box>
          <Chip
            label="Auto-linked"
            size="small"
            sx={{
              ml: "auto",
              backgroundColor: "#dcfce7",
              color: "#166534",
              fontWeight: 500,
              fontSize: "11px",
            }}
          />
          <Chip
            label="Associate Payroll Admin"
            size="small"
            sx={{
              backgroundColor: "#eff6ff",
              color: "#1d4ed8",
              fontWeight: 500,
              fontSize: "11px",
            }}
          />
        </Box>

        <Box className="newrole-container">
          <Box className="customer-photos">{/* Image upload preserved */}</Box>
          <Box className="admin-details">
              <input
    type="hidden"
    name="role"
    value={configVariables.associatePayrollAdminId}
  />
            <CustomForm
              formName="newagent"
              fieldRendererType="registration"
              onSubmit={handleSubmit}
              buttonText="Add Associate"
              loadingButtonText="Adding Associate..."
              twoColumns={true}
              buttonInPanel={true}
              roles={roles}
              isRegistration={true}  
               formValues={{
    role: configVariables.associatePayrollAdminId, // ← pre-selected
  }}
            />
          </Box>
        </Box>
      </Box>

      <CustomAlert
        severity={alert.severity}
        show={alert.showAlert}
        header={alert.header}
        message={alert.message}
        onClick={() => {
          setAlert({ ...alert, showAlert: false });
          if (alert.severity === "success") {
            setUpdateUser(!updateUser);
            handleCloseModal();
          }
        }}
        autoclose={false}
      />
    </BaseDrawer>
  );
}

export default PayrollAssociateCreation;
